// Add to frontend/src/mocks/reinsurance/cedentsData.js

export const mockCedentsList = {
  success: true,
  count: 5,
  data: [
    {
      cedent_id: "ced1-4a5b-6c7d-8e9f0a1b2c3d",
      cedent_name: "Global Insurance Co.",
      cedent_domicile: "Bermuda",
      cedent_type: "Insurance Company",
      active_contracts: 3,
      total_premium: 3750000,
      am_best_rating: "A"
    },
    {
      cedent_id: "ced2-5y6z-7a8b-9c0d1e2f3g4h",
      cedent_name: "Pacific Mutual",
      cedent_domicile: "Singapore",
      cedent_type: "Insurance Company",
      active_contracts: 2,
      total_premium: 2250000,
      am_best_rating: "A-"
    },
    {
      cedent_id: "ced3-6a7b-8c9d-0e1f2g3h4i5j",
      cedent_name: "Atlantic Re",
      cedent_domicile: "Bermuda",
      cedent_type: "Reinsurance Company",
      active_contracts: 1,
      total_premium: 3000000,
      am_best_rating: "A"
    },
    {
      cedent_id: "ced4-7k8l-9m0n-1o2p3q4r5s6t",
      cedent_name: "Midwest Insurance",
      cedent_domicile: "United States",
      cedent_type: "Insurance Company",
      active_contracts: 1,
      total_premium: 1800000,
      am_best_rating: "A+"
    },
    {
      cedent_id: "ced5-8u9v-0w1x-2y3z4a5b6c7d",
      cedent_name: "European Assurance",
      cedent_domicile: "Switzerland",
      cedent_type: "Insurance Company",
      active_contracts: 1,
      total_premium: 2700000,
      am_best_rating: "A++"
    }
  ]
};

export const mockCedentDetails = {
  "ced1-4a5b-6c7d-8e9f0a1b2c3d": {
    success: true,
    data: {
      cedent_id: "ced1-4a5b-6c7d-8e9f0a1b2c3d",
      cedent_name: "Global Insurance Co.",
      cedent_domicile: "Bermuda",
      cedent_type: "Insurance Company",
      cedent_rating: {
        am_best: "A",
        sp: "A+",
        moodys: "A2",
        fitch: "A"
      },
      contact_information: {
        address: {
          street: "123 Reinsurance Blvd",
          city: "Hamilton",
          state: "",
          postal_code: "HM 12",
          country: "Bermuda"
        },
        primary_contact: {
          name: "John Smith",
          title: "Chief Underwriting Officer",
          email: "john.smith@globalinsurance.com",
          phone: "+1-441-555-1234"
        },
        secondary_contact: {
          name: "Sarah Johnson",
          title: "Reinsurance Manager",
          email: "sarah.johnson@globalinsurance.com",
          phone: "+1-441-555-5678"
        }
      },
      financial_information: {
        currency: "USD",
        annual_premium_volume: 250000000,
        total_assets: 1500000000,
        am_best_financial_size_category: "XII",
        solvency_ratio: 215
      },
      underwriting_information: {
        lines_of_business: ["Property", "Casualty", "Marine", "Aviation"],
        territories: ["North America", "Europe", "Asia Pacific"],
        underwriting_approach: "Traditional with selective specialty focus",
        risk_appetite: "Moderate to high"
      },
      relationship_information: {
        relationship_since: "2018-01-01T00:00:00Z",
        broker_relationships: [
          {
            broker_name: "Reinsurance Brokers Ltd.",
            broker_contact: "Michael Chen"
          },
          {
            broker_name: "Global Re Intermediaries",
            broker_contact: "Emma Wilson"
          }
        ],
        notes: "Strong relationship with consistent premium growth. Prefer face-to-face meetings for renewals."
      },
      metadata: {
        created_at: "2023-05-15T10:30:00Z",
        updated_at: "2024-03-20T14:45:00Z",
        created_by: "user123",
        updated_by: "user456",
        tags: ["tier_1", "property_focus", "bermuda"]
      }
    }
  },
  "ced2-5y6z-7a8b-9c0d1e2f3g4h": {
    success: true,
    data: {
      cedent_id: "ced2-5y6z-7a8b-9c0d1e2f3g4h",
      cedent_name: "Pacific Mutual",
      cedent_domicile: "Singapore",
      cedent_type: "Insurance Company",
      cedent_rating: {
        am_best: "A-",
        sp: "A",
        moodys: "A3",
        fitch: "A-"
      },
      contact_information: {
        address: {
          street: "456 Marine Way",
          city: "Singapore",
          state: "",
          postal_code: "018956",
          country: "Singapore"
        },
        primary_contact: {
          name: "David Lee",
          title: "Head of Reinsurance",
          email: "david.lee@pacificmutual.com",
          phone: "+65-6123-4567"
        },
        secondary_contact: {
          name: "Michelle Tan",
          title: "Senior Underwriter",
          email: "michelle.tan@pacificmutual.com",
          phone: "+65-6123-7890"
        }
      },
      financial_information: {
        currency: "SGD",
        annual_premium_volume: 180000000,
        total_assets: 950000000,
        am_best_financial_size_category: "X",
        solvency_ratio: 195
      },
      underwriting_information: {
        lines_of_business: ["Marine", "Property", "Engineering", "Specialty"],
        territories: ["Asia Pacific", "Middle East"],
        underwriting_approach: "Technical with strong marine focus",
        risk_appetite: "Moderate"
      },
      relationship_information: {
        relationship_since: "2020-03-15T00:00:00Z",
        broker_relationships: [
          {
            broker_name: "Marine Reinsurance Brokers",
            broker_contact: "Sarah Johnson"
          }
        ],
        notes: "Growing relationship with strong marine expertise. Expanding into specialty lines."
      },
      metadata: {
        created_at: "2020-03-20T09:15:00Z",
        updated_at: "2024-02-10T11:30:00Z",
        created_by: "user789",
        updated_by: "user456",
        tags: ["tier_2", "marine_focus", "asia_pacific"]
      }
    }
  },
  "ced3-6a7b-8c9d-0e1f2g3h4i5j": {
    success: true,
    data: {
      cedent_id: "ced3-6a7b-8c9d-0e1f2g3h4i5j",
      cedent_name: "Atlantic Re",
      cedent_domicile: "Bermuda",
      cedent_type: "Reinsurance Company",
      cedent_rating: {
        am_best: "A",
        sp: "A",
        moodys: "A2",
        fitch: "A"
      },
      contact_information: {
        address: {
          street: "789 Reinsurance Row",
          city: "Hamilton",
          state: "",
          postal_code: "HM 15",
          country: "Bermuda"
        },
        primary_contact: {
          name: "Robert Williams",
          title: "CEO",
          email: "robert.williams@atlanticre.com",
          phone: "+1-441-555-9012"
        },
        secondary_contact: {
          name: "Jennifer Davis",
          title: "Chief Underwriting Officer",
          email: "jennifer.davis@atlanticre.com",
          phone: "+1-441-555-3456"
        }
      },
      financial_information: {
        currency: "USD",
        annual_premium_volume: 350000000,
        total_assets: 2100000000,
        am_best_financial_size_category: "XIII",
        solvency_ratio: 225
      },
      underwriting_information: {
        lines_of_business: ["Property Catastrophe", "Specialty", "Casualty"],
        territories: ["Global"],
        underwriting_approach: "Analytics-driven with parametric solutions",
        risk_appetite: "High for parametric, moderate for traditional"
      },
      relationship_information: {
        relationship_since: "2021-01-01T00:00:00Z",
        broker_relationships: [
          {
            broker_name: "Global Reinsurance Brokers",
            broker_contact: "Michael Chen"
          }
        ],
        notes: "Innovative partner with strong analytics capabilities. Interested in parametric solutions."
      },
      metadata: {
        created_at: "2021-01-15T11:45:00Z",
        updated_at: "2024-01-20T16:20:00Z",
        created_by: "user123",
        updated_by: "user789",
        tags: ["tier_1", "parametric_focus", "bermuda"]
      }
    }
  }
};

export const mockCreateCedentResponse = {
  success: true,
  message: "Cedent created successfully",
  data: {
    cedent_id: "ced6-9e0f-1g2h-3i4j5k6l7m8n",
    cedent_name: "New Insurance Company"
  }
};

export const mockUpdateCedentResponse = {
  success: true,
  message: "Cedent updated successfully",
  data: {
    cedent_id: "ced1-4a5b-6c7d-8e9f0a1b2c3d",
    cedent_name: "Global Insurance Co. (Updated)",
    version: 2
  }
};